import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <span className="font-serif text-2xl font-bold text-charcoal">Look Who's Moving</span>
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            <Link
              to="/"
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/')
                  ? 'text-primary'
                  : isScrolled
                  ? 'text-charcoal hover:text-primary'
                  : 'text-white hover:text-primary-light'
              }`}
            >
              Home
            </Link>
            <Link
              to="/removals"
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/removals')
                  ? 'text-primary'
                  : isScrolled
                  ? 'text-charcoal hover:text-primary'
                  : 'text-white hover:text-primary-light'
              }`}
            >
              Removals
            </Link>
            <Link
              to="/landscaping-services"
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/landscaping-services')
                  ? 'text-primary'
                  : isScrolled
                  ? 'text-charcoal hover:text-primary'
                  : 'text-white hover:text-primary-light'
              }`}
            >
              Landscaping Services
            </Link>
            <a
              href="tel:+27798768956"
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-charcoal hover:text-primary' : 'text-white hover:text-primary-light'
              }`}
            >
              <i className="ri-phone-line mr-2"></i>
              079 876 8956
            </a>
            <a
              href="https://wa.me/27798768956"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-primary text-white px-6 py-3 rounded-full font-medium hover:bg-primary-dark transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Get Quote
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-2xl cursor-pointer w-10 h-10 flex items-center justify-center"
            aria-label="Toggle menu"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} ${isScrolled ? 'text-charcoal' : 'text-white'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 bg-white rounded-lg shadow-lg">
            <div className="flex flex-col space-y-4 px-6 py-4">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isActive('/') ? 'text-primary' : 'text-charcoal hover:text-primary'
                }`}
              >
                Home
              </Link>
              <Link
                to="/removals"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isActive('/removals') ? 'text-primary' : 'text-charcoal hover:text-primary'
                }`}
              >
                Removals
              </Link>
              <Link
                to="/landscaping-services"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isActive('/landscaping-services') ? 'text-primary' : 'text-charcoal hover:text-primary'
                }`}
              >
                Landscaping Services
              </Link>
              <a
                href="tel:+27798768956"
                className="font-medium text-charcoal hover:text-primary transition-colors cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                079 876 8956
              </a>
              <a
                href="https://wa.me/27798768956"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary text-white px-6 py-3 rounded-full font-medium hover:bg-primary-dark transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                Get Quote
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
